import * as model from "@/model/prd/productionPlan/DowntimePlan";
import { newEntityStoreHelper } from "@/store/common/entityModule";

import router from "@/router/index";

function newFilter(paginationFilter = {}) {
    var filter = Object.assign({}, paginationFilter, model.filter)
    return filter;
}


export default newEntityStoreHelper(() => new model.DowntimePlan(), newFilter)
    .withStates({
        idReport: 2,
        locations: [],

        baseModuleUrl: process.env.VUE_APP_PRODUCTION_API_URL + "production-service/prd"
    }) //TODO load at the application start
    .withActions({
        
         
         loadLocations(context) {
            context.dispatch("api/get", {
                    url: process.env.VUE_APP_MASTER_API_URL + "master-service/master" + "/location/findAll"
                }, { root: true })
                .then(function(data) {
                    context.commit("setLocations", data);
                })
        }
    })
    .withMutations({
        setLocations(state, locations) {
            state.locations = locations;
        } 
    })
    .buildStore()



    